import {ReactNode, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';

const PortalFooter = ({children}: {children: ReactNode}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current = document.querySelector('#message-footer');
  }, []);

  return ref.current ? ReactDOM.createPortal(children, ref.current) : null;
};

export default PortalFooter;
